"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
var type_rest_1 = require("type-rest");
var apiRoot = process.env.API_ROOT ? process.env.API_ROOT : process.env.VUE_APP_API_ROOT;
exports.Api = (0, type_rest_1.typeRest)(apiRoot, {
    params: {
        mode: "cors",
    },
    hooks: [
        {
            type: "post",
            hook: function (ev) {
                var response = ev.response;
                if (response.status === 403) {
                    console.log("TYPE REST HOOK");
                }
            },
        },
        {
            type: "post",
            path: "/auth/",
            method: "POST",
            hook: function (ev) {
                var response = ev.response;
                ev.instance._options.params.headers.token = response.token;
            },
        },
        {
            type: "post",
            path: "/auth/",
            method: "DELETE",
            hook: function (ev) {
                var response = ev.response;
                if (response.valid) {
                    ev.instance._options.params.headers.token = undefined;
                    delete ev.instance._options.params.headers.token;
                }
            },
        },
    ],
});
//# sourceMappingURL=index.js.map